import { configureStore } from '@reduxjs/toolkit'
import appReducer from './app-slice';
import workOderReducer from './work-order-slice';
import workHistoryReducer from './work-history-slice';
import workReportReducer from './work-report-slice';

export default configureStore({
  reducer: {
    app: appReducer,
    orders: workOderReducer,
    history: workHistoryReducer,
    reports: workReportReducer,
  },
});